export const isRunningInDesktop = !!window.Bridge

export const isRunningInBrowser = !isRunningInDesktop
